
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("eaUFb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $42377a0c64a3913d$export$2e2bcd8739ae039);

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $xb2jO = parcelRequire("xb2jO");

var $6Wh6Q = parcelRequire("6Wh6Q");
parcelRequire("dHfHd");
var $cbw6R = parcelRequire("cbw6R");

var $aI0YR = parcelRequire("aI0YR");

var $7vVE3 = parcelRequire("7vVE3");
const $42377a0c64a3913d$var$selector = (0, $BOq7h.createSelector)((0, $aI0YR.getUserState), (0, $aI0YR.getDisplayName), (0, $cbw6R.getShouldOpenFeedbackWidget), (0, $cbw6R.getShowTypeField), (0, $cbw6R.getAdditionalFields), (0, $cbw6R.getCustomComponent), (userState, name, shouldOpenFeedbackWidget, showTypeField, additionalFields, CustomComponent)=>({
        name: name,
        showTypeField: showTypeField,
        additionalFields: additionalFields,
        CustomComponent: CustomComponent,
        isOpen: shouldOpenFeedbackWidget,
        accountId: userState.accountId
    }));
const $42377a0c64a3913d$var$mapDispatchToProps = {
    hideFeedbackCollector: $6Wh6Q.hideFeedbackCollector,
    updateAdditionalFieldsInFeedbackCollector: $6Wh6Q.updateAdditionalFieldsInFeedbackCollector,
    showSuccessFlag: $xb2jO.showSuccessFlag
};
var $42377a0c64a3913d$export$2e2bcd8739ae039 = (0, $egQxE.connect)($42377a0c64a3913d$var$selector, $42377a0c64a3913d$var$mapDispatchToProps)((0, $7vVE3.default));

});
parcelRegister("dHfHd", function(module, exports) {
$parcel$export(module.exports, "getShouldOpenFeedbackWidget", () => (parcelRequire("cbw6R")).getShouldOpenFeedbackWidget);
$parcel$export(module.exports, "getShowTypeField", () => (parcelRequire("cbw6R")).getShowTypeField);
$parcel$export(module.exports, "getAdditionalFields", () => (parcelRequire("cbw6R")).getAdditionalFields);
$parcel$export(module.exports, "getCustomComponent", () => (parcelRequire("cbw6R")).getCustomComponent);

var $cbw6R = parcelRequire("cbw6R");

});
parcelRegister("cbw6R", function(module, exports) {
$parcel$export(module.exports, "getShouldOpenFeedbackWidget", () => $d02c5fc6eae079db$export$f0c3dadd8fc7dfed);
$parcel$export(module.exports, "getShowTypeField", () => $d02c5fc6eae079db$export$99318df27e085ae7);
$parcel$export(module.exports, "getAdditionalFields", () => $d02c5fc6eae079db$export$a2649d59716eb83a);
$parcel$export(module.exports, "getCustomComponent", () => $d02c5fc6eae079db$export$df419fe580dd6a0);
const $d02c5fc6eae079db$export$f0c3dadd8fc7dfed = (state)=>{
    return state.ui.feedbackCollector.shouldOpenFeedbackWidget;
};
const $d02c5fc6eae079db$export$99318df27e085ae7 = (state)=>{
    return state.ui.feedbackCollector.showTypeField;
};
const $d02c5fc6eae079db$export$a2649d59716eb83a = (state)=>{
    return state.ui.feedbackCollector.additionalFields;
};
const $d02c5fc6eae079db$export$df419fe580dd6a0 = (state)=>{
    return state.ui.feedbackCollector.CustomComponent;
};

});


parcelRegister("7vVE3", function(module, exports) {
$parcel$export(module.exports, "default", () => $7687749800c5b185$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");
var $4vLTk = parcelRequire("4vLTk");

var $87QgR = parcelRequire("87QgR");

var $aE7ei = parcelRequire("aE7ei");
parcelRequire("4e0zs");
var $cn0Vw = parcelRequire("cn0Vw");

var $kdWly = parcelRequire("kdWly");

var $kfhVd = parcelRequire("kfhVd");
const $7687749800c5b185$var$getFeedbackGroupLabels = (intl)=>{
    return {
        question: {
            fieldLabel: intl.formatMessage((0, $kfhVd.default).questionFieldLabel),
            selectOptionLabel: intl.formatMessage((0, $kfhVd.default).questionSelectOptionLabel)
        },
        comment: {
            fieldLabel: intl.formatMessage((0, $kfhVd.default).commentFieldLabel),
            selectOptionLabel: intl.formatMessage((0, $kfhVd.default).commentSelectOptionLabel)
        },
        bug: {
            fieldLabel: intl.formatMessage((0, $kfhVd.default).bugFieldLabel),
            selectOptionLabel: intl.formatMessage((0, $kfhVd.default).bugSelectOptionLabel)
        },
        suggestion: {
            fieldLabel: intl.formatMessage((0, $kfhVd.default).suggestionFieldLabel),
            selectOptionLabel: intl.formatMessage((0, $kfhVd.default).suggestionSelectOptionLabel)
        },
        empty: {
            fieldLabel: intl.formatMessage((0, $kfhVd.default).emptyFieldLabel),
            selectOptionLabel: intl.formatMessage((0, $kfhVd.default).emptySelectOptionLabel)
        }
    };
};
const $7687749800c5b185$var$FeedbackPreamble = (props)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const CustomComponent = props.CustomComponent;
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, (0, $87QgR.default).checkGate('jsm_rename_product_to_app') ? formatMessage((0, $kfhVd.default).feedbackPreambleTitleTextAppify, {
        // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        p: (chunks)=>/*#__PURE__*/ $bSJIT.createElement("p", null, chunks),
        br: /*#__PURE__*/ $bSJIT.createElement("br", null)
    }) : formatMessage((0, $kfhVd.default).feedbackPreambleTitleText, {
        // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        p: (chunks)=>/*#__PURE__*/ $bSJIT.createElement("p", null, chunks),
        br: /*#__PURE__*/ $bSJIT.createElement("br", null)
    }), CustomComponent && /*#__PURE__*/ $bSJIT.createElement(CustomComponent, null));
};
const $7687749800c5b185$var$CanBeContactedLabel = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ $bSJIT.createElement("p", null, formatMessage((0, $kfhVd.default).canContactLabelText, {
        a: (chunks)=>/*#__PURE__*/ $bSJIT.createElement("a", {
                href: (0, $kdWly.linkToSupport),
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks)
    })));
};
const $7687749800c5b185$var$EnrolLabel = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ $bSJIT.createElement("p", null, (0, $87QgR.default).checkGate('jsm_rename_product_to_app') ? formatMessage((0, $kfhVd.default).enrolLabelTextAppify, {
        a: (chunks)=>/*#__PURE__*/ $bSJIT.createElement("a", {
                href: (0, $kdWly.linkToSupport),
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks)
    }) : formatMessage((0, $kfhVd.default).enrolLabelText, {
        a: (chunks)=>/*#__PURE__*/ $bSJIT.createElement("a", {
                href: (0, $kdWly.linkToSupport),
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks)
    })));
};
const $7687749800c5b185$export$97c796bf9b7231ea = ({ accountId: accountId, name: name, isOpen: isOpen, showTypeField: showTypeField, additionalFields: additionalFields, CustomComponent: CustomComponent, intl: intl, hideFeedbackCollector: hideFeedbackCollector, showSuccessFlag: showSuccessFlag, updateAdditionalFieldsInFeedbackCollector: updateAdditionalFieldsInFeedbackCollector })=>{
    const close = $bSJIT.useCallback(()=>{
        hideFeedbackCollector();
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const displayFlag = $bSJIT.useCallback(()=>{
        showSuccessFlag((0, $kfhVd.default).feedbackSentFlagTitle, undefined, (0, $87QgR.default).checkGate('jsm_rename_product_to_app') ? (0, $kfhVd.default).feedbackSentFlagDescriptionAppify : (0, $kfhVd.default).feedbackSentFlagDescription);
    }, [
        showSuccessFlag
    ]);
    const onAdditionalFieldChange = $bSJIT.useCallback((fieldId, fieldValue)=>{
        const fields = {
            ...additionalFields
        };
        fields[fieldId] = fieldValue;
        updateAdditionalFieldsInFeedbackCollector(fields);
    }, // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        additionalFields
    ]);
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-testid": "portal-feedback-collector"
    }, isOpen && /*#__PURE__*/ $bSJIT.createElement((0, $aE7ei.default), {
        onClose: close,
        onSubmit: displayFlag,
        atlassianAccountId: accountId,
        name: name,
        entrypointId: (0, $kdWly.feedbackWidgetData).entrypointId,
        feedbackTitle: intl.formatMessage((0, $kfhVd.default).feedbackTitle),
        showTypeField: showTypeField,
        feedbackTitleDetails: /*#__PURE__*/ $bSJIT.createElement($7687749800c5b185$var$FeedbackPreamble, {
            CustomComponent: CustomComponent ? (0, $cn0Vw.default)({
                additionalFields: additionalFields,
                onChange: onAdditionalFieldChange
            })(CustomComponent) : undefined
        }),
        canBeContactedLabel: /*#__PURE__*/ $bSJIT.createElement($7687749800c5b185$var$CanBeContactedLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ $bSJIT.createElement($7687749800c5b185$var$EnrolLabel, null),
        summaryPlaceholder: intl.formatMessage((0, $kfhVd.default).summaryPlaceholder),
        submitButtonLabel: intl.formatMessage((0, $kfhVd.default).submitButtonLabel),
        cancelButtonLabel: intl.formatMessage((0, $kfhVd.default).cancelButtonLabel),
        feedbackGroupLabels: $7687749800c5b185$var$getFeedbackGroupLabels(intl)
    }));
};
var $7687749800c5b185$export$2e2bcd8739ae039 = (0, $fK3tS.default)($7687749800c5b185$export$97c796bf9b7231ea);

});
parcelRegister("4e0zs", function(module, exports) {
$parcel$export(module.exports, "withAdditionalFieldsComponent", () => (parcelRequire("cn0Vw")).default);

var $cn0Vw = parcelRequire("cn0Vw");

});
parcelRegister("cn0Vw", function(module, exports) {
$parcel$export(module.exports, "default", () => $02a2ca977911283e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $02a2ca977911283e$var$withAdditionalFieldsComponent = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            return /*#__PURE__*/ $bSJIT.createElement(WrappedComponent, {
                ...props,
                onChange: options.onChange,
                additionalFields: options.additionalFields
            });
        };
        ReturnComponent.displayName = 'WithAdditionalFieldsComponent';
        return ReturnComponent;
    };
var $02a2ca977911283e$export$2e2bcd8739ae039 = $02a2ca977911283e$var$withAdditionalFieldsComponent;

});


parcelRegister("kdWly", function(module, exports) {
$parcel$export(module.exports, "linkToSupport", () => $8ecc04f6d776b970$export$746803d2321eee0d);
$parcel$export(module.exports, "feedbackWidgetData", () => $8ecc04f6d776b970$export$1114e7c220cd5fae);
const $8ecc04f6d776b970$export$746803d2321eee0d = 'https://support.atlassian.com/contact/#/';
const $8ecc04f6d776b970$export$1114e7c220cd5fae = {
    entrypointId: 'f914e972-dc30-4b2c-ab56-fbd0964085c0'
};

});

parcelRegister("kfhVd", function(module, exports) {
$parcel$export(module.exports, "default", () => $1eeb3c99d5100b06$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $1eeb3c99d5100b06$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    feedbackPreambleTitleText: {
        defaultMessage: '<p>Your thoughts are valuable in helping improve our products.</p>{br}',
        description: 'Introductory preamble text shown at the top of the product feedback form',
        id: 'sd.feedback.collector.feedback.preamble.title.text'
    },
    feedbackPreambleTitleTextAppify: {
        defaultMessage: '<p>Your thoughts are valuable in helping improve our apps.</p>{br}',
        description: 'Introductory preamble text shown at the top of the apps feedback form',
        id: 'sd.feedback.collector.feedback.preamble.title.text-appify'
    },
    canContactLabelText: {
        defaultMessage: 'Atlassian can contact me about this feedback. See our <a>privacy policy</a>',
        description: 'Checkbox label allowing Atlassian to contact the user about their feedback',
        id: 'sd.feedback.collector.can.contact.label.text'
    },
    enrolLabelText: {
        defaultMessage: "I'd like to help improve Atlassian products by joining the <a>Atlassian Research Group</a>",
        description: 'Checkbox label inviting user to join the Atlassian Research Group for products',
        id: 'sd.feedback.collector.enrol.label.text'
    },
    enrolLabelTextAppify: {
        defaultMessage: "I'd like to help improve Atlassian apps by joining the <a>Atlassian Research Group</a>",
        description: 'Checkbox label inviting user to join the Atlassian Research Group for apps',
        id: 'sd.feedback.collector.enrol.label.text-appify'
    },
    feedbackTitle: {
        defaultMessage: 'Share your thoughts',
        description: 'Heading displayed at the top of the feedback collector dialog',
        id: 'sd.feedback.collector.feedback.title'
    },
    summaryPlaceholder: {
        defaultMessage: "Let us know what's on your mind",
        description: 'Placeholder text shown in the feedback summary input field before user types',
        id: 'sd.feedback.collector.summary.placeholder'
    },
    questionSelectOptionLabel: {
        defaultMessage: 'Ask a question',
        description: 'Select option label for Question',
        id: 'sd.feedback.collector.question.select.option.label'
    },
    questionFieldLabel: {
        defaultMessage: 'What would you like to know?',
        description: 'Label to be shown when user chooses question from drop down',
        id: 'sd.feedback.collector.question.field.label'
    },
    commentSelectOptionLabel: {
        defaultMessage: 'Leave a comment',
        description: 'Select option label for Comment',
        id: 'sd.feedback.collector.comment.select.option.label'
    },
    commentFieldLabel: {
        defaultMessage: "Let us know what's on your mind",
        description: 'Label to be shown when user chooses comment from drop down',
        id: 'sd.feedback.collector.comment.field.label'
    },
    bugSelectOptionLabel: {
        defaultMessage: 'Report a bug',
        description: 'Dropdown option label for selecting to report a bug in the feedback form',
        id: 'sd.feedback.collector.bug.select.option.label'
    },
    bugFieldLabel: {
        defaultMessage: 'Describe the bug or issue',
        description: 'Label to be shown when user chooses bug from drop down',
        id: 'sd.feedback.collector.bug.field.label'
    },
    suggestionSelectOptionLabel: {
        defaultMessage: 'Suggest an improvement',
        description: 'Select option label for Suggestion',
        id: 'sd.feedback.collector.suggestion.select.option.label'
    },
    suggestionFieldLabel: {
        defaultMessage: "Let us know what you'd like to improve",
        description: 'Label to be shown when user chooses Suggestion from drop down',
        id: 'sd.feedback.collector.suggestion.field.label'
    },
    emptySelectOptionLabel: {
        defaultMessage: 'I want to...',
        description: 'Default dropdown option label shown before the user selects a feedback type',
        id: 'sd.feedback.collector.empty.select.option.label'
    },
    emptyFieldLabel: {
        defaultMessage: 'Select an option',
        description: 'Label to be shown when user chooses Empty from drop down',
        id: 'sd.feedback.collector.empty.field.label'
    },
    submitButtonLabel: {
        defaultMessage: 'Send feedback',
        description: 'Label on the submit button to send the completed feedback form',
        id: 'sd.feedback.collector.submit.button.label'
    },
    cancelButtonLabel: {
        defaultMessage: 'Cancel',
        description: 'Label on the cancel button to dismiss the feedback collector dialog',
        id: 'sd.feedback.collector.cancel.button.label'
    },
    feedbackSentFlagTitle: {
        defaultMessage: 'Thanks',
        description: 'Title of the confirmation flag shown after feedback has been submitted',
        id: 'sd.feedback.collector.feedback.sent.flag.title'
    },
    feedbackSentFlagDescription: {
        defaultMessage: 'Your valuable feedback helps us continually improve our products.',
        description: 'Body text of the confirmation flag shown after product feedback is submitted',
        id: 'sd.feedback.collector.feedback.sent.flag.description'
    },
    feedbackSentFlagDescriptionAppify: {
        defaultMessage: 'Your valuable feedback helps us continually improve our apps.',
        description: 'Body text of the confirmation flag shown after apps feedback is submitted',
        id: 'sd.feedback.collector.feedback.sent.flag.description-appify'
    }
});

});



parcelRegister("iS8wm", function(module, exports) {
$parcel$export(module.exports, "Fieldset", () => $be42dc6f630a8f17$export$e154be390aa0e14);
/* fieldset.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $91vAL = parcelRequire("91vAL");
const $be42dc6f630a8f17$var$fieldSetStyles = null;
const $be42dc6f630a8f17$export$e154be390aa0e14 = ({ children: children, legend: legend })=>{
    return /*#__PURE__*/ (0, $dc70d.jsxs)("fieldset", {
        className: (0, $9fU1q.default)([
            "_1pfhu2gc"
        ]),
        children: [
            legend && /*#__PURE__*/ (0, $dc70d.jsx)((0, $91vAL.Legend), {
                children: legend
            }),
            children
        ]
    });
};

});
parcelRegister("91vAL", function(module, exports) {
$parcel$export(module.exports, "Legend", () => $246f719b71dedcfd$export$ed247974535929c7);
/* legend.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $246f719b71dedcfd$var$fieldsetLabelStyles = null;
const $246f719b71dedcfd$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("legend", {
        className: (0, $9fU1q.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});



//# sourceMappingURL=feedback-collector.15af2594.js.map
